const { gql } = require("@apollo/client");

export const GET_TRAMO_PROFESIONAL = gql`
  query getTramoProfesional($idDelegacion: Int!, $idTipoProfesional: Int!) {
    tramoProfesional(
      idDelegacion: $idDelegacion
      idTipoProfesional: $idTipoProfesional
    ) {
      idHonorarioProfesionalAjuste
      descripcion
      valor
    }
  }
`;
